/**
 *  @class
 *  @function PredictiveSearch
 */
class PredictiveSearch {
  constructor() {
    this.container = document.getElementById('Search-Drawer');
    this.form = this.container.querySelector('form.searchform');
    this.button = document.querySelectorAll('.thb-quick-search');
    this.input = this.container.querySelector('input[type="search"]');
    this.defaultTab = this.container.querySelector('.side-panel-content--initial');
    this.predictiveSearchResults = this.container.querySelector('.side-panel-content--has-tabs');
    
    // Add scroll target element (the content that needs to scroll within the search drawer)
    this.scrollableContent = this.container.querySelector('.clerk_wrapper');

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
    
    // Add focus listeners to handle keyboard interactions
    this.input.addEventListener('focus', () => {
      if (window.searchScrollLock) {
        window.searchScrollLock.disable();
      }
    });
    
    this.input.addEventListener('blur', () => {
      // Only enable scroll if the search drawer is still active
      if (!this.container.classList.contains('active') && window.searchScrollLock) {
        window.searchScrollLock.enable();
      }
    });

    this.button.forEach((item, i) => {
      item.addEventListener('click', (event) => {
        var _this = this;
        event.preventDefault();
        document.getElementsByTagName("body")[0].classList.toggle('open-cc');
        document.getElementsByTagName("html")[0].classList.toggle('open-cc-search');
        this.container.classList.toggle('active');
        
        if (this.container.classList.contains('active')) {
          // Lock body scroll when search drawer is opened
          if (window.searchScrollLock) {
            window.searchScrollLock.disable();
          }
          
          setTimeout(function () {
            _this.input.focus({
              preventScroll: true
            });
          }, 100);
          dispatchCustomEvent('search:open');
        } else {
          // Unlock body scroll when search drawer is closed
          if (window.searchScrollLock) {
            window.searchScrollLock.enable();
          }
        }

        return false;
      });
    });
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.predictiveSearchResults.classList.remove('active');
      return;
    }
    this.predictiveSearchResults.classList.add('active');
    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    }
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();

    this.predictiveSearchResults.classList.add('loading');

    fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,article,query&${encodeURIComponent('resources[limit]')}=10&section_id=predictive-search`)
      .then((response) => {
        this.predictiveSearchResults.classList.remove('loading');
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        throw error;
      });
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    let _this = this,
      submitButton = this.container.querySelector('#search-results-submit');


    submitButton.addEventListener('click', () => {
      _this.form.submit();
    });
  }

  close() {
    this.container.classList.remove('active');
    // Unlock body scroll when search drawer is closed
    if (window.searchScrollLock) {
      window.searchScrollLock.enable();
    }
  }
}
window.addEventListener('load', () => {
  if (typeof PredictiveSearch !== 'undefined') {
    new PredictiveSearch();
  }
  
  // Handle click on the click-capture div to close search drawer and enable scrolling
  const clickCapture = document.querySelector('.click-capture');
  if (clickCapture) {
    clickCapture.addEventListener('click', () => {
      const searchDrawer = document.getElementById('Search-Drawer');
      if (searchDrawer && searchDrawer.classList.contains('active') && window.searchScrollLock) {
        window.searchScrollLock.enable();
      }
    });
  }
  
  // Handle closing the search drawer with Escape key
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const searchDrawer = document.getElementById('Search-Drawer');
      if (searchDrawer && searchDrawer.classList.contains('active') && window.searchScrollLock) {
        window.searchScrollLock.enable();
      }
    }
  });
});